@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.promocodes

import com.narbase.letsgo.dto.core.DateDto

data class PromoCodeDto(
    val id: Int?,
    val code: String,
    val amount: Double,
    val uses: Int?,
    val expiration: DateDto?,
    val zoneId: Int?,
)
